<template>
    <v-container class="pa-0" fluid>
        <transition name="page">
            <router-view />
        </transition>
    </v-container>
</template>

<script>
export default {
    name: 'BBTracking'
}
</script>
